import { AxiosResponse } from 'axios';
import { getValueList } from 'civil-status/constants/states-act';
import { ActListVM } from 'civil-status/view-models/research-form';
import { DateTime } from 'luxon';
import { ActBozza } from 'shell/models/act-list';
import { HttpResponseList, HttpResponseListPayload } from 'shell/models/http-response';

export const transformerActEmergencyList = (
  response: AxiosResponse<HttpResponseList<ActBozza>>
): Array<ActListVM> => {
  const listResponse = (response.data?.payload || []) as unknown as Array<ActBozza>;
  const totalCount = ((response.data as unknown as HttpResponseListPayload<ActBozza>)?.pageInfo
    ?.totalCount || 0) as number;

  return listResponse.map((item) => ({
    idAct: item.idEvento?.toString() || '',
    subject: `${item.cognome || ''} ${item.nome || ''}${
      item.cognome2 || item.nome2 ? `; ${item.cognome2 || ''} ${item.nome2 || ''}` : ''
    }`,
    date: item.decorrenzaAtto ? DateTime.fromISO(item?.decorrenzaAtto).toFormat('dd/MM/yyyy') : '',
    dateLastUpdate: item.dataUltimoAggiornamento
      ? DateTime.fromISO(item?.dataUltimoAggiornamento).toFormat('dd/MM/yyyy')
      : '',
    registerEmergency: item.descrRegistroDiEmergenza || '',
    nameOperator: item.cognomeNomeOperatore || '',
    typeAct: item.contenuto || '',
    state: getValueList(item.codiceStato),
    number: item.numeroAttoRegistroDiEmergenza || '',
    totalCount,
  }));
};
